var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.8335 21.6167V11.65C3.8335 7.05004 7.56683 3.33337 12.1668 3.33337H28.8335C33.4335 3.33337 37.1668 7.05004 37.1668 11.65V23.2834C37.1668 27.8667 33.4335 31.5834 28.8335 31.5834H26.3335C25.8168 31.5834 25.3168 31.8334 25.0002 32.25L22.5002 35.5667C21.4002 37.0334 19.6002 37.0334 18.5002 35.5667L16.0002 32.25C15.7335 31.8834 15.1335 31.5834 14.6668 31.5834H12.1668C7.56683 31.5834 3.8335 27.8667 3.8335 23.2834V21.6167Z",
    fill: "#FF4378"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5002 20C19.5668 20 18.8335 19.25 18.8335 18.3333C18.8335 17.4166 19.5835 16.6666 20.5002 16.6666C21.4168 16.6666 22.1668 17.4166 22.1668 18.3333C22.1668 19.25 21.4335 20 20.5002 20Z",
    fill: "#FF4378"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1667 20C26.2333 20 25.5 19.25 25.5 18.3333C25.5 17.4166 26.25 16.6666 27.1667 16.6666C28.0833 16.6666 28.8333 17.4166 28.8333 18.3333C28.8333 19.25 28.1 20 27.1667 20Z",
    fill: "#FF4378"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8332 20C12.8998 20 12.1665 19.25 12.1665 18.3333C12.1665 17.4166 12.9165 16.6666 13.8332 16.6666C14.7498 16.6666 15.4998 17.4166 15.4998 18.3333C15.4998 19.25 14.7665 20 13.8332 20Z",
    fill: "#FF4378"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.3ef1eef8dccac45c708fd970eca691aa.svg";
export { ForwardRef as ReactComponent };